import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
    const router = useRouter();
    const { locale, asPath } = router;
    const { i18n } = useTranslation();

    // Define the list of supported locales/options
    const locales = [
        // The value passed to the option is 'en' or 'fr'
        { value: 'en', label: 'English (EN)', display: 'EN' }, 
        { value: 'fr', label: 'Français (FR)', display: 'FR' },
    ];
    
    // console.log('locale', locale)

    return (
        <select
            // 1. Set the initial value of the selector to the current Next.js locale
            value={locale}
            onChange={(e) => {
                const newLocale = e.target.value;
                
                // 2. Update the i18n instance state
                i18n.changeLanguage(newLocale);
                
                // 3. Update the Next.js route, preserving the path (asPath)
                router.push(asPath, asPath, { locale: newLocale });
            }}
        >
            {/* Map over the locales array to generate options */}
            {locales.map((lang) => (
                // The value attribute remains the short code ('en', 'fr')
                <option key={lang.value} value={lang.value}>
                    {lang.label}
                </option>
            ))}
        </select>
    );
}




